import {
  Button,
  Divider,
  Flex,
  VStack,
  Text,
  InputGroup,
  Input,
  InputRightElement,
  Box,
} from '@chakra-ui/react';
import { borders } from '../../theme';
import CustomImage from '../../components/CustomImage';
import bgImg from '../../assets/homepageBg.svg';
import logo from '../../assets/logo.svg';
import blurImg from '../../assets/blurBg.png';
import Footer from '../../components/Footer';
import CustomConnectButton from '../../components/ConnectWalletButton';
type HomeMobileProps = {
  onStartNewGame: () => void;
  inviteLink: string;
  setInviteLink: (link: string) => void;
  onPaste: () => void;
  isPasting: boolean;
};

const HomeMobile = ({
  onStartNewGame,
  inviteLink,
  setInviteLink,
  onPaste,
  isPasting,
}: HomeMobileProps) => {
  return (
    <Flex
      flexDirection={'column'}
      px={'1rem'}
      pos={'relative'}
      overflow={'hidden'}
      w="100%"
      gap={'2rem'}
    >
      <Flex width={'100%'} justifyContent={'flex-end'} mt={'1rem'}>
        <CustomConnectButton fontSize={'1.4rem'} h={'3.6rem'} />
      </Flex>
      <Box>
        <Flex
          flexDir={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          pos="relative"
          width={'33.5rem'}
          m={'0 auto'}
          pt={'5rem'}
        >
          <CustomImage
            src={bgImg}
            alt="background"
            pos="absolute"
            width={'100%'}
            height={'26.4rem'}
            top={0}
          />
          <CustomImage src={logo} alt="logo" width={'18.5rem'} />

          <Text textStyle="h1" mt="2rem" fontSize={'2rem'}>
            TEXAS HOLD'EM IN 3 EASY STEPS
          </Text>
          <Text
            textStyle="p1"
            mt="1rem"
            w="100%"
            textAlign={'center'}
            fontSize={'1.1rem'}
          >
            1. Create a game link
          </Text>
          <Text
            textStyle="p1"
            w="100%"
            textAlign={'center'}
            fontSize={'1.1rem'}
          >
            2. Send the link to your friends
          </Text>
          <Text
            textStyle="p1"
            w="100%"
            textAlign={'center'}
            fontSize={'1.1rem'}
          >
            3. Deposit your buy-in into the vault and starting playing.
          </Text>
        </Flex>
      </Box>

      <Box
        border={borders.normal}
        borderRadius={'1.5rem'}
        w={'34rem'}
        maxW={{ base: 'unset', lg: '32rem' }}
        bg={'gray1304'}
        backdropFilter={'blur(2rem)'}
        m={'0 auto 0'}
        p={'2rem 3rem'}
      >
        <Text textStyle={'h1'} textAlign={'center'} fontSize={'2.4rem'}>
          Poker with Friends
          <br />
          Settled Onchain
        </Text>
        <VStack spacing={'1rem'} mt={'4rem'} w="100%">
          <Button
            variant={'normal'}
            h={'3.6rem'}
            w="100%"
            onClick={onStartNewGame}
            fontSize={'1.2rem'}
          >
            Start a New Game
          </Button>
          <Flex
            gap={'1rem'}
            position="relative"
            w="100%"
            textStyle="p3"
            alignItems={'center'}
          >
            <Divider w="44%" borderColor={'whiteAlpha.400'} />
            <Text>OR</Text>
            <Divider w="44%" borderColor={'whiteAlpha.400'} />
          </Flex>
          <InputGroup>
            <Input
              textStyle={'p3'}
              _placeholder={{
                fontSize: '1rem',
                color: 'whiteAlpha.400',
                lineHeight: '121%',
                fontWeight: 'medium',
              }}
              pr="4.5rem"
              border={borders.white20}
              color="white"
              placeholder="Enter Your Invite Link"
              value={inviteLink}
              onChange={e => {
                setInviteLink(e.currentTarget.value);
              }}
              w={'100%'}
              h={'3.6rem'}
            />
            <InputRightElement width="4.5rem" h="3.6rem" pr="0.5rem">
              <Button
                variant={'normal'}
                borderRadius={'4px'}
                h="2.1rem"
                size="sm"
                onClick={onPaste}
                isLoading={isPasting}
                isDisabled={!inviteLink}
                fontSize={'1rem'}
              >
                Paste
              </Button>
            </InputRightElement>
          </InputGroup>
        </VStack>
      </Box>

      <Flex
        width={'100%'}
        position={'absolute'}
        bottom={'1rem'}
        left={'0'}
        justifyContent={'center'}
      >
        <Footer linkStyle={{ height: '1.8rem', minWidth: '1.8rem' }} />
      </Flex>
      <CustomImage
        src={blurImg}
        alt="background"
        w={'90rem'}
        h={'64rem'}
        pos="absolute"
        top="50%"
        left="50%"
        transform={'translate(-50%, -50%)'}
        zIndex="-2"
      />
    </Flex>
  );
};

export default HomeMobile;
